// Display helpers for a topic's audit history (History tab).

import type { TalkTrackAuditEntry } from "../../types/talkTrack";
import { clientLabel } from "../connectedAgents/format";

const ACTION_LABEL: Record<string, string> = {
  topic_create: "created topic",
  topic_update: "edited topic settings",
  topic_delete: "deleted topic",
  draft_open: "opened draft",
  draft_save: "saved draft",
  draft_discard: "discarded draft",
  submit: "submitted for review",
  request_changes: "requested changes",
  approve: "approved",
  publish: "published",
  set_rollout: "changed rollout",
  promote: "promoted candidate",
  rollback: "rolled back candidate",
  restore: "restored",
  enable: "enabled topic",
  disable: "disabled topic",
  comment_add: "commented",
  comment_resolve: "resolved comment",
  comment_reopen: "reopened comment",
  simulation_start: "started simulation",
};

export function actionLabel(action: string): string {
  return ACTION_LABEL[action] ?? action.replace(/_/g, " ");
}

const v = (n: number | null) => (n === null ? "—" : `v${n}`);

// How a release action moved the topic's pointers: "live v1 → v2", ...
export function pointerMoves(e: TalkTrackAuditEntry): string[] {
  const moves: string[] = [];
  if (e.liveFrom !== e.liveTo) moves.push(`live ${v(e.liveFrom)} → ${v(e.liveTo)}`);
  if (e.candidateFrom !== e.candidateTo) moves.push(`candidate ${v(e.candidateFrom)} → ${v(e.candidateTo)}`);
  if (e.rolloutFrom !== e.rolloutTo && e.rolloutFrom !== null && e.rolloutTo !== null) {
    moves.push(`rollout ${e.rolloutFrom}% → ${e.rolloutTo}%`);
  }
  if (e.enabledFrom !== e.enabledTo && e.enabledFrom !== null && e.enabledTo !== null) {
    moves.push(e.enabledTo ? "enabled" : "disabled");
  }
  return moves;
}

export function isMcp(e: TalkTrackAuditEntry): boolean {
  return e.via === "mcp";
}

// The MCP badge's tooltip: which agent, and the change request it executed.
export function mcpTitle(e: TalkTrackAuditEntry): string {
  const parts = [`Through MCP: ${clientLabel(e.clientId)}`];
  if (e.changeId) parts.push(`change ${e.changeId}`);
  if (e.approvedBy) parts.push(`approved by ${e.approvedBy}`);
  return parts.join(" · ");
}
